import 'angular';
import './ApprovalLevelController';
import './approval_level_template.html'

angular.module('GorillaBoy.Approvals')
.directive('approvalLevel', () => {
    return {
        restrict: 'E',
        scope: {
            level : '='
        },
        templateUrl: './approvals/approvalLevelModal/approvalLevelDirective/approval_level_template.html',
        controller: 'ApprovalLevelController'
    }
});